import TrustPilot from './TrustPilot'

export default TrustPilot
